import { Box, Typography, useTheme } from '@mui/material';
import { UpdatedByTypes } from 'src/types/alarms';
import { formatUTCDateToLocal } from 'src/utilities';

type Props = {
  updatedBy: UpdatedByTypes;
  updatedAt: string;
};
//formatUTCDateToLocal
export const LastEditedInfoBox = ({ updatedBy, updatedAt }: Props) => {
  const theme = useTheme();
  const darkGrey = theme.palette.grey[600];

  const textStyle = {
    fontSize: '12px',
    fontWeight: '500',
    color: darkGrey,
  };

  const nonSuperAdminUser = `${updatedBy?.firstName} ${updatedBy?.lastName}`;
  const superAdminUser = 'System Admin';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {updatedAt && (
        <Typography sx={textStyle}>
          Last edited: {formatUTCDateToLocal(false, updatedAt)}
        </Typography>
      )}
      {updatedBy?.type && (
        <Typography sx={textStyle}>
          Edited by: {updatedBy?.type === 'System' ? superAdminUser : nonSuperAdminUser}
        </Typography>
      )}
    </Box>
  );
};
